export default __webpack_public_path__ + "static/media/cross.2af7e09f.svg";